import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import * as completeTask from '../../../../redux/healthboard/requests/complete-task-req';
import * as completeTaskCustom from '../../../../redux/healthboard/requests/complete-task-custom-req';
import { targetUserIdSelector } from '../../../../redux/context/selectors';
import {
  selectCompleteTaskError,
  selectCompleteTaskSucceed,
  selectCompleteTaskPending,
  selectCompleteTaskCustomPending,
  selectCompleteTaskCustomSucceed,
  selectCompleteTaskCustomError,
} from '../../../../redux/healthboard/selectors';

const mapStateToProps = state => ({
  pending: selectCompleteTaskPending(state),
  succeed: selectCompleteTaskSucceed(state),
  error: selectCompleteTaskError(state),
  userId: targetUserIdSelector(state),
  custom: {
    pending: selectCompleteTaskCustomPending(state),
    succeed: selectCompleteTaskCustomSucceed(state),
    error: selectCompleteTaskCustomError(state),
  },
});
const mapDispatchToProps = {
  completeCustom: completeTaskCustom.actions.start,
  clearCustom: completeTaskCustom.actions.clear,
  complete: completeTask.actions.start,
  clear: completeTask.actions.clear,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/TaskDetailsPopup/enhance.js